import { EmptyState } from '@c42/component-library';
import { BrandColors } from '@c42/material-ui-theme';
import { AlertCircle } from 'mdi-material-ui';
import React from 'react';
import Text from '../../shared/Text';
import CommonStaticLayout from './common-static-layout';

const SsoAuthLoginIncorrect: React.FC = () => {
  const isElectron = navigator.userAgent.indexOf('Electron') >= 0;

  React.useEffect(() => {
    document.title = Text.get('sso_doc_title_error');
  }, []);

  return (
    <CommonStaticLayout noPadding>
      <EmptyState
        icon={<AlertCircle htmlColor={BrandColors.BoldBlue} />}
        title={Text.get('ssoAuthSignIn_incorrect_message1')}
        subtitle={
          isElectron
            ? Text.get('ssoAuthSignIn_incorrect_message2')
            : Text.get('ssoAuthSignIn_incorrect_message2_browser')
        }
        PaperProps={{ elevation: 0 }}
      />
    </CommonStaticLayout>
  );
};

export default SsoAuthLoginIncorrect;
